import React, { useState, useRef, useEffect, Link } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext.js";
import { Cookies } from '../../index.js';
import axios from 'axios';
import { Helmet } from "react-helmet";
import { useParams } from 'react-router-dom';
import { ClipLoader, PulseLoader } from 'react-spinners';
import BitmediaAd from './bitmedia';
import GeeTest, { GeeTestRef } from 'react-geetest-v4';
import AdSense from 'react-adsense';
import Language_i18 from '../../js/useNationalLanguage.jsx';
const TaskList = () => {
    // Định nghĩa nhãn đa ngôn ngữ
    const translate = {
        en: {
            confirm: 'Confirm',
            wait: 'Wait a moment',
            thankYou: 'Thank you for your support',
            error: 'An error occurred, please try again',
            tryNow: 'Try Now',
            provider: 'Provider',
            description: 'Description',
            taskName: 'Task Name',
            reward: 'Reward',
            confirmAction: 'Confirm'
        },
        vi: {
            confirm: 'Xác nhận',
            wait: 'Đợi xíu nhé',
            thankYou: 'Cảm ơn bạn đã ủng hộ',
            error: 'Đã xảy ra lỗi vui lòng nhập lại',
            tryNow: 'Thử ngay',
            provider: 'Nhà cung cấp',
            description: 'Mô tả',
            taskName: 'Tên nhiệm vụ',
            reward: 'Phần quà',
            confirmAction: 'Xác nhận'
        }
    };
    const { i18n, lang } = Language_i18();

    const { slug_2 } = useParams();
    const [nutorder, setnutorder] = useState(translate[lang]?.confirm);
    const [gtoken, setgtoken] = useState('');
    const [taskid, settaskid] = useState('');
    const [category, setcategory] = useState('');
    const [urllink, seturllink] = useState('');
    const [nutxuly, setnutxuly] = useState(0);
    const [showmission, setshowmission] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [tasks, settasks] = useState([
        { id: 1, name: 'Tạo profile shop', description: 'Nhận ngay 20 Coins', url: '/reactapp/baohiem' },
        { id: 2, name: 'Đặt Banner lên App', description: 'Nhận ngay 1500 Coins + 100% hạn mức', url: '/shop/ads/adsprofiles' },
        { id: 3, name: 'Mua 1 đơn tăng tương tác kênh hệ mặt trời', description: 'Nhận ngay 100 Coins' },
        { id: 4, name: 'Mua 1 đơn mem nhóm, kênh telegram việt', description: 'Nhận ngay 100 Coins' },
        // Thêm nhiệm vụ khác tại đây
    ]);
    const captchaRef = useRef(null);
    const handleLoaded = _ => {
        window.grecaptcha.ready(_ => {
            window.grecaptcha
                .execute("6LfIRiYeAAAAAH42UB0tN41k5vDRf2OfChCIKxkn", { action: "homepage" })
                .then(token => {
                    console.log(token);
                    setgtoken(token);
                })
        })
    }
    const resetRecaptcha = () => {
        if (slug_2 == 'rollup') {

        }
        else {
            const oldRecaptchaElement = document.querySelector('.g-recaptcha');

            if (oldRecaptchaElement) {
                // Xóa reCAPTCHA cũ
                oldRecaptchaElement.remove();
            }

            // Tạo một phần tử div mới để chứa reCAPTCHA mới
            const newRecaptchaDiv = document.createElement('div');
            newRecaptchaDiv.className = 'g-recaptcha';
            newRecaptchaDiv.setAttribute('data-sitekey', '6LfIRiYeAAAAAH42UB0tN41k5vDRf2OfChCIKxkn');
            newRecaptchaDiv.setAttribute('data-size', 'invisible');

            // Thêm phần tử mới vào DOM
            document.body.appendChild(newRecaptchaDiv);

            // Tải lại reCAPTCHA mới
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute("6LfIRiYeAAAAAH42UB0tN41k5vDRf2OfChCIKxkn", { action: "homepage" })
                    .then(token => {
                        console.log(token);
                        setgtoken(token);
                    });
            });
        }
    };
    useEffect(() => {
        // Add reCaptcha
        if (slug_2 != 'rollup') {
            const script = document.createElement("script")
            script.src = "https://www.google.com/recaptcha/api.js?render=6LfIRiYeAAAAAH42UB0tN41k5vDRf2OfChCIKxkn"
            script.addEventListener("load", handleLoaded)
            document.body.appendChild(script)
        }
    }, [])

    function checkxacthuc() {
        const myCookieValue = Cookies.get('apikey');
        axios.get('https://hust.media/jop/telegram/checkxacthuc.php?apikey=' + myCookieValue)
            .then((response) => {
                testFunction(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    }

    const navigate = useNavigate();
    const ok_api = (value, geetoken) => {
        if (value) {
            setnutxuly(1);
            setIsDisabled(true);
            setnutorder(translate[lang]?.wait);
            const myCookieValue = Cookies.get('apikey');
            let data = JSON.stringify({
                "service": value,
                "apikey": myCookieValue,
                "gtoken": gtoken,
                "geetoken": geetoken,
                "category": category
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://hust.media/jop/mission/1short.php',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios.post(config.url, config.data, config.headers)
                .then((response) => {
                    setnutxuly(0);
                    testFunction(response);
                    resetRecaptcha();
                    setIsDisabled(false);
                })
                .catch((error) => {
                    setnutxuly(0);
                    alert_error(error);
                    resetRecaptcha();
                    setIsDisabled(false);
                });
        }
        else {
            alert_error(translate[lang]?.error);
        }
    }
    const handleGeetestSuccess = (result) => {
        // Xử lý khi xác thực thành công
        setIsOpen(false);
        console.log(result);
        // setgeetoken(result);
        ok_api(taskid, result);
    };
    const submit = (value) => {
        if (slug_2 == 'rollup') {
            setOpenTaskId(value);
            setIsOpen(true);
            settaskid(value);
        }
        else {
            ok_api(value);
        }
    };
    function clickmission(taskIdToFind) {
        if (!isDisabled) {
            const task = tasks.find(task => task.id === taskIdToFind);
            if (task) {
                const link = task.url; // Nếu không có URL, trả về giá trị mặc định
                if (link) {
                    if (link.includes("https") || link.includes("hustmedia.duckdns.org")) {
                        if (category == 'offerwall') {
                            const myCookieValue = Cookies.get('apikey');
                            window.location.href = link + '&apikey=' + myCookieValue;
                        }
                        else {
                            window.location.href = link;
                        }
                    } else {
                        const name = task.name; // Nếu không có URL, trả về giá trị mặc định
                        const userAgent = navigator.userAgent.toLowerCase();
                        if (userAgent.includes('hustmedianative') && name == 'Bitlabs') {
                            // User agent chứa chuỗi "hustmedianative"
                            const myCookieValue = Cookies.get('apikey');
                            window.location.href = '/api/website/redirect.php?url=' + link + '&apikey=' + myCookieValue + '&app=googleadservices' + '&app=uiviewcontroller';
                        }
                        else {
                            navigate(link);
                        }
                    }
                }
                else {
                    console.log(category);
                    if (category == 'rollup' || category == 'offerwall') {
                        submit(taskIdToFind);
                    }
                    console.log(`không có url`);
                }
            } else {
                console.log(`Không tìm thấy nhiệm vụ với id ${taskIdToFind}`);
            }
        }
    };
    function switch_router(taskIdToFind) {
        if (!isDisabled) {
            const task = tasks.find(task => task.id === taskIdToFind);
            if (task) {
                const link = task.url; // Nếu không có URL, trả về giá trị mặc định
                if (link) {
                    navigate(link);
                }
                else {
                    console.log(category);
                    if (category == 'rollup' || category == 'offerwall') {
                        submit(taskIdToFind);
                    }
                    console.log(`không có url`);
                }
            } else {
                console.log(`Không tìm thấy nhiệm vụ với id ${taskIdToFind}`);
            }
        }
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutxuly(0);
        if (status == 1) {
            setnutorder(translate[lang]?.thankYou);
            alert_success(message);
        }
        else if (status == 0) {
            alert_error(message);
        }
        else {
            setnutorder(translate[lang]?.error);
            alert_error(translate[lang]?.error);
        }
        setnutorder(translate[lang]?.confirm);
        if (info.redirect != null && info.redirect != '') {
            if (category == 'rollup') {
                seturllink(info.redirect);
                setIsOpen(true);
            }
             
            else {
                setTimeout(function () {
                    // Chuyển hướng sang trang web khác
                    window.location.href = info.redirect;
                }, 1700);
            }
        }
    };
    function laythongtin(category) {
        // setmisson(false);
        const myCookieValue = Cookies.get('apikey');
        axios.get('https://nginx.hust.media/go/mission/p2p_link/checklink', {
            params: {
                apikey: myCookieValue,
                category: category
            }
        })
            .then(response => {
                if (response.data.status == 0) {
                    alert_error(response.data.message);
                }
                else {
                    console.log(response.data); // Dữ liệu từ API
                    settasks(response.data);
                    setshowmission(true);
                    // setdata(response.data);
                    // setdalaythongtin(true);
                    // Xử lý dữ liệu ở đây
                }
                if (response.data.redirect != null && response.data.redirect != '') {
                    setTimeout(function () {
                        // Chuyển hướng sang trang web khác
                        window.location.href = response.data.redirect;
                    }, 2000);
                }
            })
            .catch(error => {
                setshowmission(true);
                alert_error(error);
            });
    };
    useEffect(() => {
        if (slug_2 == 'rollup' || slug_2 == 'offerwall' || slug_2 == '1short') {
            if (slug_2 != '1short') {
                laythongtin(slug_2);
            }
            else {
                checkxacthuc();
            }
            setcategory(slug_2);
        }
        else {
            checkxacthuc();
        }
    }, []);
    const [openTaskId, setOpenTaskId] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const handleClose = () => {
        setIsOpen(false);
        seturllink('');
    };
    return (
        <>
            <div className="w-full mt-1">
                {category == "offerwall" ? (<>
                </>) : (<>
                    <div id="M882924ScriptRootC1520508"></div>
                    <Helmet>
                        <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>
                    </Helmet>
                    <BitmediaAd />
                </>)}
                {(category == 'rollup' || category == 'offerwall') && showmission == false ? (<>
                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                        <ClipLoader color="#fff" size={150} />
                    </div>
                </>) : (
                    <>
                        <div className="flex flex-wrap  justify-center">
                            <iframe
                                data-aa="2271984"
                                src="//ad.a-ads.com/2271984?size=320x50"
                                frameBorder="0"
                                scrolling="no"
                                allowFullScreen
                                style={{
                                    width: '320px',
                                    height: '50px',
                                    border: 0,
                                    padding: 0,
                                    overflow: 'hidden',
                                    backgroundColor: 'transparent'
                                }}
                            ></iframe>
                            <iframe
                                data-aa="2271984"
                                src="//ad.a-ads.com/2271984?size=320x50"
                                frameBorder="0"
                                scrolling="no"
                                allowFullScreen
                                style={{
                                    width: '320px',
                                    height: '50px',
                                    border: 0,
                                    padding: 0,
                                    overflow: 'hidden',
                                    backgroundColor: 'transparent'
                                }}
                            ></iframe>

                        </div>
                        <div className="mx-2 mt-1">
                            <table className="w-full border shadow-lg rounded-lg">
                                <thead className="bg-blue-500 text-white">
                                    {category == "offerwall" ? (<>
                                        <tr className="lg:table-row">
                                            <th className="border px-3 py-2 w-3/6">{translate[lang]?.provider}</th>
                                            <th className="border px-3 py-2 w-5/6">{translate[lang]?.description}</th>
                                            {/* <th className="border px-3 py-2 w-2/6">Xác nhận</th> */}
                                        </tr>
                                    </>) : (<>
                                        <tr className="lg:table-row">
                                            <th className="border px-3 py-2 w-3/6">{translate[lang]?.taskName}</th>
                                            <th className="border px-3 py-2 w-5/6">{translate[lang]?.reward}</th>
                                            <th className="border px-3 py-2 w-2/6">{translate[lang]?.confirmAction}</th>
                                        </tr>
                                    </>)}

                                </thead>
                                <tbody>
                                    {tasks.map((task) => (
                                        <tr key={task.id} className="hover:bg-gray-100">
                                            <td className="border px-6 py-3 lg:w-2/5 px-3 py-2 ">
                                                <div className="flex items-center justify-between flex-1"
                                                    onClick={() => clickmission(task.id)} >
                                                    {task.name}
                                                    <div className="text-xl">
                                                        {'\u27A4'}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="border px-6 py-3 lg:w-2/5 px-3 py-2">
                                                <div dangerouslySetInnerHTML={{ __html: task.description }} />
                                            </td>

                                            <td className="border  text-center">
                                                <button disabled={isDisabled} onClick={() => submit(task.id)} className="group rounded-2xl h-12 w-55 bg-pink-300 font-bold text-base text-white relative overflow-hidden">
                                                    {nutxuly == 1 && (<span className="spinner-border spinner-border-sm"></span>)}
                                                    {nutorder}
                                                    <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                                                </button>
                                                {isOpen && (
                                                    <div>
                                                        {openTaskId === task.id && (
                                                            <div minimum-scale="1" maximum-scale="1" className="absolute z-10 mt-1
                                                        right-3
                                                        rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">

                                                                <div
                                                                    className="py-1"
                                                                    role="menu"
                                                                    aria-orientation="vertical"
                                                                    aria-labelledby="options-menu"
                                                                >
                                                                    <div className="flex">
                                                                        {urllink ? (<>
                                                                            <a href={urllink} target="_blank" >
                                                                                <button className="ml-3 bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition duration-300 ease-in-out">
                                                                                    {translate[lang]?.tryNow}
                                                                                </button>
                                                                            </a>
                                                                        </>) : (
                                                                            <GeeTest
                                                                                captchaId={'2367e368fef71fff0bf119f963985786'}
                                                                                containerId={'fecfead39968d5617f9a50a9bde75c48'} // Optional
                                                                                onSuccess={(result) => handleGeetestSuccess(result)}
                                                                                onReady={() => console.log('ready')}
                                                                                ref={captchaRef}
                                                                                className="mx-auto" // Thêm lớp mx-auto để căn giữa theo chiều ngang
                                                                            />
                                                                        )}

                                                                        <button
                                                                            onClick={() => handleClose()}
                                                                            className='text-xl mr-2'>✖</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="mx-2">
                            <div className="max-w-2xl mx-2 mx-auto">
                                <div className="cards">
                                    <AdSense.Google
                                        client="ca-pub-4574266110812955"
                                        slot="5828045161"
                                        style={{ display: 'block' }}
                                        format="auto"
                                        responsive="true"
                                    />
                                </div> </div>
                        </div>
                        {/* <div className="flex flex-wrap  justify-center">
                            <iframe
                                data-aa="2271984"
                                src="//ad.a-ads.com/2271984?size=320x50"
                                frameBorder="0"
                                scrolling="no"
                                allowFullScreen
                                style={{
                                    width: '320px',
                                    height: '50px',
                                    border: 0,
                                    padding: 0,
                                    overflow: 'hidden',
                                    backgroundColor: 'transparent'
                                }}
                            ></iframe>
                            <iframe
                                data-aa="2271984"
                                src="//ad.a-ads.com/2271984?size=320x50"
                                frameBorder="0"
                                scrolling="no"
                                allowFullScreen
                                style={{
                                    width: '320px',
                                    height: '50px',
                                    border: 0,
                                    padding: 0,
                                    overflow: 'hidden',
                                    backgroundColor: 'transparent'
                                }}
                            ></iframe>
                        </div> */}
                    </>)}
            </div>
        </>

    );
};

export default TaskList;